function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceModel1CircleTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    width: 120,
    height: 120,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 8,
      fill: "#dddd56",
      stroke: "#ffffff"
    },
    cx: 60,
    cy: 60,
    r: 50
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceModel1CircleTemp);
export default __webpack_public_path__ + "static/media/place_model-1_circle_temp.438a02836200f46d71a89ee0a9147491.svg";
export { ForwardRef as ReactComponent };